var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uploadCom t_center"},[_c('div',[_vm._t("block")],2),_c('input',{ref:"input",attrs:{"type":"file","accept":"image/*","multiple":""},on:{"change":function($event){return _vm.imgChang(this)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }